<template>

  <div class="form newSubmission" v-if="hasTimeLeft">

    <form v-if="isWaiting && isStepCheck" name="checkContestant" @submit.prevent="checkContestant">

      <div class="formGroup">
        <span class="formGroup__label">E-mail<i class="formGroup__req">*</i></span>
        <input class="formGroup__input" type="text" v-model="newSubmission.email">
      </div>

      <button type="submit" class="formGroup__button" :class="{ 'formGroup__button--visible': isEmailValid }">Nastavi</button>

    </form>
    <NewContestant v-if="isWaiting && isStepRegister" @email="storeEmail" :inputEmail="newSubmission.email" />
    <form v-if="isWaiting && isStepSubmit" name="newSubmission" @submit.prevent="registerSubmission">

      <div class="formGroup">
        <span class="formGroup__label">Rješenje (mora biti .txt)<i class="formGroup__req">*</i></span>
        <input class="formGroup__input" accept="text/plain" type="file" @change="registerFile" ref="fileLoc">
      </div>

      <input type="input" class="formGroup__honey" v-model="newSubmission.honey" aria-hidden="true" tabindex="-1">
      <button type="submit" class="formGroup__button" :class="{ 'formGroup__button--visible': isValidForm }">Predaj</button>

    </form>
    <template v-else>
      <div v-if="isNetworking">
        <h3>Trenutak...</h3>
        <p v-if="remote.file">Ako šalješ veliki dokument, pričekaj malo da se uploada. Svoje rezultate sačuvaj na računalu jer rješenja ne spremamo na serveru.</p>
      </div>
      <div v-if="isError">
        <h3>Ajoj!</h3>
        <p>Došlo je do nepoznate pogreške. Molimo te da nam se javiš na suncobraniranje[at]phishar.com</p>
      </div>
      <div v-if="isSuccess">
        <h3>Bravo!</h3>
        <p>Uspješno si predao svoje rješenje. Evo rezultata:</p>
        <pre>{{ remote.message }}</pre>
      </div>
      <div v-if="isWrong">
        <h3>Nešto ne štima!</h3>
        <p>Čini se da tvoje predano rješenje nije dobro, evo što kaže naš sustav:</p>
        <pre>{{ remote.message }}</pre>
      </div>
    </template>

  </div>
  <div v-else>
    <p>Isteklo je vrijeme za predaju rješenja</p>
  </div>

</template>
<script>
import axios from 'axios'
import NewContestant from '@/components/NewContestant'
axios.defaults.headers.common['Authorization'] = Date.now()
const submissionUrl = `https://api.suncobraniranje.phishar.com/newSubmission`
const checkUrl = `https://api.suncobraniranje.phishar.com/checkContestant`
export default {
  data() {
    return {
      step: 'check',
      remote: {
        status: 'waiting',
        message: '',
        file: false
      },
      newSubmission: {
        email: '',
        file: false,
        honey: ''
      }
    }
  },
  components: {
    NewContestant
  },
  computed: {
    hasTimeLeft() {
      return (Date.now() < (1636185600 * 1000))
    },
    storageAlias() {
      return window.localStorage.getItem('suncobraniranjeAlias') || null
    },
    isStepCheck() {
      return this.step === 'check'
    },
    isStepSubmit() {
      return this.step === 'submit'
    },
    isStepRegister() {
      return this.step === 'register'
    },
    isWaiting() {
      return this.remote.status === 'waiting'
    },
    isSuccess() {
      return this.remote.status === 'success'
    },
    isError() {
      return this.remote.status === 'error'
    },
    isNetworking() {
      return this.remote.status === 'networking'
    },
    isWrong() {
      return this.remote.status === 'wrong'
    },
    isEmailValid() {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.newSubmission.email)
    },
    isValidForm() {

      if (!this.isEmailValid) return false
      if (!this.newSubmission.file) return false
      if (this.newSubmission.honey !== '') return false

      return true
    }
  },
  methods: {
    registerFile(event) {
      if (!event.target.files.length) {
        this.newSubmission.file = false
        return
      }

      if (event.target.files.length > 1) {
        this.newSubmission.file = false
        return
      }

      let ext = event.target.files[0].name.substr(-3,3).toLowerCase()
      if (ext !== 'txt') {
        this.newSubmission.file = false
        return
      }

      this.newSubmission.file = true
    },
    async checkContestant() {

      const formData = new FormData()
      formData.append('email', this.newSubmission.email)

      this.remote.status = 'networking'

      await axios
      .post(checkUrl, formData)
      .then(({ status, data }) => {
        this.remote.status = 'waiting'
        this.step = 'submit'
      })
      .catch(error => {
        this.remote.status = 'waiting'
        this.step = 'register'
      })

    },
    storeEmail(email) {
      this.newSubmission.email = email
      this.remote.status = 'waiting'
      this.step = 'submit'
    },
    async registerSubmission() {
      if (!this.isValidForm) return false
      if (this.isNetworking) return false

      this.remote.status = 'networking'
      this.remote.file = true


      const formData = new FormData()
      formData.append('email', this.newSubmission.email)
      formData.append('file', this.$refs.fileLoc.files[0])

      await axios
      .post(submissionUrl, formData)
      .then(({ status, data }) => {

        if (status === 201) {
          this.remote.status = 'success'
          this.remote.message = data.msg
        } else {
          this.remote.status = 'wrong'
          this.remote.message = data.msg
        }

      })
      .catch(error => {
        const status = error.response.status
        this.remote.status = 'error'
      })

    }
  }
}
</script>
